

























import { Component, Inject, InjectReactive, Vue } from 'vue-property-decorator';

import { User } from '@/api';
import { FeedProduct } from '../../models';

import UsersTable from '@/components/tables/users-table.vue';
import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';
import { canAddUsers } from '@/services/user-service';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import { getOtherActionText } from '@/common/HelpTextUtils';

@Component({
	methods: { getOtherActionText },
	components: {
		UsersTable,
		AddUserForm,
		TooltipButton,
	},
})
export default class FeedProductUsersTab extends Vue {
	@InjectReactive('feedProduct')
	private feedProduct!: FeedProduct;

	@Inject('refreshFeedProduct')
	public refresh!: () => Promise<void>;

	@InjectReactive('feedProductAllowedUserIds')
	public allowedUserIds!: number[] | null;

	@InjectReactive('feedCanAddUser')
	public canAddUser!: boolean;

	public get users(): User[] {
		return this.feedProduct.users;
	}
}
